import { spinClockwise, spinCounterclockwise } from '../../styles/animations';

const spinDirection = (spin) => {
  switch (spin) {
    case 'clockwise':
      return spinClockwise;
    case 'counterclockwise':
      return spinCounterclockwise;
    default:
      return '';
  }
};

const iconRotate = (flip) => {
  switch (flip) {
    case ('vertical'):
      return 'scale(1, -1)';
    case ('horizontal'):
      return 'scaleX(-1)';
    default:
      return '';
  }
};

export {
  spinDirection,
  iconRotate
};
